const INIT_STATE = [];
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_FILE_SUCCESS":
      if (action.payload.persistOnStore) return [...state, action.payload];
      else return state;
    case "GET_FILE_ERROR":
      return [...state];
    default:
      return state;
  }
};
